import React from 'react';
import BearImage from '../../assets/images/special/bear-lady-cinder-teddy.webp';

function BulletStar() {
  return (
    <svg
      viewBox='0 0 24 24'
      className='w-4 h-4'
      fill='currentColor'
      aria-hidden='true'
    >
      <path d='M12 2l2.7 6.7 7.3.6-5.6 4.7 1.8 7-6.2-3.8-6.2 3.8 1.8-7L2 9.3l7.3-.6L12 2z' />
    </svg>
  );
}

export default function CardsAndBearDisplay() {
const features = [
  "I am not just a goddess — I am a deity. When you enter my orbit, you surrender.",
  "My eyes are ever watching; I slow your breath, pull you under, and make obedience feel inevitable.",
  "Hypnosis is my signature — triggers, mantras, cadence — my words echo long after the session ends.",
  "Sensual sadism: silk over flame. I read your reactions and tune the sting to the edge you crave.",
  "Mindfuck & propaganda play — I'll rewrite your story until my voice lives in your head.",
  "Precision first: negotiation, consent, boundaries. Then I take you farther than you planned.",
  "In person or online, I hold you in perfect focus. Distance never dilutes devotion.",
  "Aftercare is deliberate; I leave you floating, marked, and desperate to earn another audience.",
  "Once you embrace it, you belong to me — and you will prove it with tribute and discipline.",
  "You don’t book a session; you petition for my time. Impress me."
];

  return (
    <section className='grid w-full min-h-screen bg-colour2 text-colour1'>
      <div className='grid md:grid-cols-2 items-center gap-x-12 px-12 lg:px-24 py-16'>
        {/* LEFT: tall portrait stack */}
        <div className='grid place-items-center'>
          <div className='relative w-64 sm:w-72 lg:w-80 z-10'>
            {/* back card */}
            <div className='absolute inset-0 translate-x-6 translate-y-6 rotate-3'>
              <div className='h-[32rem] rounded-3xl bg-colour3 shadow-cardShadowBold' />
            </div>

            {/* front card with overflow visible so image can spill over ring */}
            <div className='-rotate-6'>
              <div className='neon-border rounded-3xl'>
                <div className='h-[32rem] lg:h-[36rem] rounded-3xl ring-2 hero-teddy ring-colour1 bg-colour2 shadow-cardShadow grid place-items-center p-8 overflow-visible relative'>
                  <img
                    src={BearImage}
                    alt='Lady Cinder bear artwork'
                    loading='lazy'
                    className='w-full h-full object-contain scale-150 md:-translate-x-8 lg:-translate-x-10 drop-shadow'
                    draggable='false'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT: features panel (unchanged) */}
        <aside className='grid place-items-start'>
          <div className='relative grid gap-y-8 rounded-3xl bg-colour3 shadow-cardShadowBold ring-1 ring-black/40 p-12 w-full max-w-lg'>
            <div className='absolute right-8 top-8 grid gap-y-2'>
              <span className='block w-5 h-5 rotate-45 bg-colour1/90 shadow-cardShadow' />
              <span className='block w-4 h-4 rotate-45 bg-colour1/80 shadow-cardShadow' />
              <span className='block w-3 h-3 rotate-45 bg-colour1/70' />
            </div>

            <h2 className='text-4xl md:text-5xl font-fancyFont leading-tight'>
              Special Features:
            </h2>

            <ul className='grid gap-y-4 text-base leading-relaxed'>
              {features.map((t) => (
                <li key={t} className='grid grid-cols-reg items-start gap-x-4'>
                  <span className='grid place-items-center pt-1'>
                    <BulletStar />
                  </span>
                  <span className='lg:text-sm'>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}
